import { magicNumbers } from 'utils';

export const virastyFiltersInitialState = {
  contentTagFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'contentTagFilter',
    translateKey: 'filter:contentsTag',
  },
  wordCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'wordCloudFilter',
    translateKey: 'filter:wordCloud',
  },
  seenStatusFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both',
    componentName: 'seenStatusFilter',
    translateKey: 'filter:seenStatus',
  },
  hashtagCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'hashtagCloudFilter',
    translateKey: 'filter:hashtagCloud',
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'virasty',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
      },
      reaction: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:reactionCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
      },
      copy: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:copyCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:contentBasedOn',
  },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  contentTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both', // both or original or copy
    platform: 'virasty',
    componentName: 'contentTypeFilter',
    translateKey: 'filter:contentType',
  },
  mediaTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'virasty',
    componentName: 'mediaTypeFilter',
    translateKey: 'filter:mediaType',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
  },
  ageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'ageFilter',
    translateKey: 'filter:ageRange',
  },
  genderFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'genderFilter',
    translateKey: 'filter:gender',
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    filterType: 'include',
    hasIncludeExclude: true,
    platform: 'virasty',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'virasty',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
};
